import { Fragment } from 'react';
import DallasText from '@ui/Dallas/Text/DallasText';
import { TermsOfServiceTextPart } from '@trucksmarter/shared';
import DallasLink from '@ui/Dallas/Link/DallasLink';
import { DallasTextColor } from '@ui/Dallas/types/typography';

type TermsOfServiceCopyProps = {
  textItems: TermsOfServiceTextPart[];
  color: DallasTextColor;
};

export default function TermsOfServiceCopy({
  textItems,
  color,
}: TermsOfServiceCopyProps) {
  return (
    <DallasText color={color}>
      {textItems.map(({ text, url }, index) => (
        <Fragment key={text}>
          {url ? (
            <>
              <DallasLink
                color={color}
                underlined
                href={url}
                target="_blank"
              >{`${text}`}</DallasLink>
              {index === textItems.length - 1 ? '' : ' '}
            </>
          ) : (
            `${text} `
          )}
        </Fragment>
      ))}
    </DallasText>
  );
}
